/**
 * @flow
 * @relayHash 64651cc0d78f153d5438e69147709bc0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type HtmlTemplateUpdateInput = {|
  id: string,
  categoryTemplateId: string,
  name: string,
  tpl: string,
  isDefault: boolean,
|};
export type UpdateHtmlTemplateMutationVariables = {|
  data: HtmlTemplateUpdateInput
|};
export type UpdateHtmlTemplateMutationResponse = {|
  +updateHtmlTemplate: {|
    +id: string
  |}
|};
export type UpdateHtmlTemplateMutation = {|
  variables: UpdateHtmlTemplateMutationVariables,
  response: UpdateHtmlTemplateMutationResponse,
|};
*/


/*
mutation UpdateHtmlTemplateMutation(
  $data: HtmlTemplateUpdateInput!
) {
  updateHtmlTemplate(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "HtmlTemplateUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateHtmlTemplate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "HtmlTemplateModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateHtmlTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateHtmlTemplateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateHtmlTemplateMutation",
    "id": null,
    "text": "mutation UpdateHtmlTemplateMutation(\n  $data: HtmlTemplateUpdateInput!\n) {\n  updateHtmlTemplate(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1b935947b0b8af88cb6db1793c41effc';
module.exports = node;
